import { useQuery } from "react-query";
import { useSearchParams } from "react-router-dom";
import { useApiAccess } from "./useApiAccess";
import { getArticles } from "../../Service/ArticleService";
import { queryKeys } from "./queryKeys";

export function useCategoryArticles({ categorySlug }) {
  const hasAccess = useApiAccess();
  const [searchParams] = useSearchParams();
  const productParam = searchParams.get("product");

  const pathParams = {
    sortBy: "rank",
    sort: "DESC",
    ...(productParam && { product: productParam }),
  };

  const { data, ...rest } = useQuery(
    queryKeys.categoryArticles(categorySlug, productParam),
    () => getArticles(categorySlug, pathParams),
    { enabled: !!hasAccess && !!categorySlug }
  );

  return { data: data ?? [], ...rest };
}
